import axios from 'axios';

// No auth: used by the public batch status page (linked from submission emails and the scans page).
const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/public/batch`;

export interface BatchStatusCoverSheetLine {
    inventoryId: string | null;
    inventoryDesc: string | null;
    vendorId: string | null;
    vendorName: string | null;
    freightVendorId: string | null;
    freightVendorName: string | null;
    loads: number;
    receivedQty: number | null;
    uom: string | null;
}

export interface BatchStatusTicket {
    id: number;
    ticketNumber: string | null;
    inventoryId: string | null;
    inventoryDesc: string | null;
    receivedQty: number | null;
    uom: string | null;
    status: string | null;
}

export interface BatchStatus {
    batchId: string;
    branch: string | null;
    warehouse: string | null;
    orderDate: string;
    status: string | null;
    submittedAtUtc: string | null;
    isNoMaterial: boolean;
    processingCount: number;
    plantNotes: Array<{ note: string | null; createdDateTime: string }>;
    coverSheetSubmitted: BatchStatusCoverSheetLine[];
    coverSheetAccounting: BatchStatusCoverSheetLine[];
    tickets: BatchStatusTicket[];
}

export const getBatchStatus = async (batchId: string): Promise<BatchStatus> => {
    const res = await axios.get<BatchStatus>(`${API_URL}/${encodeURIComponent(batchId)}`);
    return res.data;
};

export const getTicketPdfUrl = (batchId: string, ticketId: number): string =>
    `${API_URL}/${encodeURIComponent(batchId)}/ticket/${ticketId}/pdf`;
